import {
    MenuSheet,
    MobileMenu,
    MobileMenuButton,
    MobileMenuButtonV1
} from "./mobileElements";
import {TopBrands} from "./topBrands";
import {ShortcutCategories} from "./shortcutCategories";
import {initializeElement} from "./utils";

initializeElement(MobileMenuButton);
initializeElement(MobileMenuButtonV1);

initializeElement(MenuSheet);
initializeElement(MobileMenu);
initializeElement(TopBrands);
initializeElement(ShortcutCategories);
